<template>
  <div class="container">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
<!--        <link rel="stylesheet" type="text/css" href="https://www.tssgroup.com.cn/style/css/font-awesome-4.7.0/css/font-awesome.css"/>-->
        <link rel="stylesheet" href="https://www.tssgroup.com.cn/style/css/qs.css?v=192" />
        <link rel="stylesheet" href="https://www.tssgroup.com.cn/style/css/ndnav02.css">
        <link rel="stylesheet" href="https://www.tssgroup.com.cn/style/css/qs-h5.css?v=91" />
<!--        <script type="text/javascript" src="https://www.tssgroup.com.cn/style/js/jquery.js" ></script>-->
<!--        <script type="text/javascript" src="https://www.tssgroup.com.cn/style/js/adaptive-version2.js" ></script>-->
<!--        <script type="text/javascript" src="https://www.tssgroup.com.cn/style/js/ndnav.js" ></script>-->
<!--        <script type="text/javascript" src="https://www.tssgroup.com.cn/style/js/exif.js"></script>-->
    <div class="header">
      <div class="center-pc-nav clearfix">
        <a href="https://www.tssgroup.com.cn/" class="logo"><img src="https://www.tssgroup.com.cn/style/images/logo1.svg" type="image/svg+xml"></a>
        <div class="pc-nav">
          <dd><a href="https://www.tssgroup.com.cn/about-us/group/" class="pc-n-a" id="pc-ts-1">走进青山</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/about-us/group/">集团简介</a>
              <a href="https://www.tssgroup.com.cn/about-us/honor/">集团荣誉</a>
              <a href="https://www.tssgroup.com.cn/about-us/video/">影像集锦</a>
            </div>
          </dd>
          <dd><a href="https://www.tssgroup.com.cn/global/steel/" class="pc-n-a" id="pc-ts-2">全球业务</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/global/steel/">不锈钢制造</a>
              <a href="https://www.tssgroup.com.cn/global2new/">新能源产业链</a>
              <a href="https://www.tssgroup.com.cn/global/innovation/">创新与发展</a>
            </div>
          </dd>
          <dd><a href="https://www.tssgroup.com.cn/peplo/duty1/" class="pc-n-a" id="pc-ts-3">社会责任</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/peplo/duty1/">生态环保</a>
              <a href="https://www.tssgroup.com.cn/peplo/duty2/">慈善公益</a>
            </div>
          </dd>
          <dd><a href="https://www.tssgroup.com.cn/ts-news/news1/" class="pc-n-a" id="pc-ts-4">资讯中心</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/ts-news/news1/">企业动态</a>
              <a href="https://www.tssgroup.com.cn/ts-news/news2-1/">行业新闻</a>
              <a href="https://www.tssgroup.com.cn/ts-news/news2/">媒体聚焦</a>
              <a href="https://www.tssgroup.com.cn/ts-news/news3/">活动剪影</a>
            </div>
          </dd>
          <dd><a  class="pc-n-a" id="pc-ts-4">廉洁青山</a>
            <div class="item">
              <a href="https://jubao.tssgroup.com.cn/start/#/news_web">廉洁文化</a>
              <a href="https://jubao.tssgroup.com.cn/start/#/borad_web">曝光台</a>
              <a href="https://jubao.tssgroup.com.cn/start">我要举报</a>
            </div>
          </dd>
          <dd><a href="https://www.tssgroup.com.cn/job/join1/" class="pc-n-a" id="pc-ts-5">加入我们</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/job/join1/">职业发展</a>
              <a href="https://www.tssgroup.com.cn/job/join2/">诚聘英才</a>
            </div>
          </dd>
          <dd><a href="https://www.tssgroup.com.cn/contact/contact-us/" class="pc-n-a" id="pc-ts-6">联系我们</a>
            <div class="item">
              <a href="https://www.tssgroup.com.cn/contact/contact-us/">联系方式</a>
              <a href="https://www.tssgroup.com.cn/contact/line/">互动留言</a>
            </div>
          </dd>
        </div>
        <div class="pc-right">
          <a href="#"><div class="fa fa-search"></div></a>
          <a href="https://mail.tssgroup.com.cn/accounts/login?system=mail" target="_blank">登录</a>
          <a href="https://www.tssgroup.com.cn/en/">EN</a>
        </div>

      </div>
    </div>

    <div class="inwarp p-b-no" style="width:99.5vw">


      <!--mbx-->
      <div class="mbx" style="text-align: left">
        <a href="https://www.tssgroup.com.cn/">首页</a><i>/</i><a href="https://jubao.tssgroup.com.cn/start/#/news_web">廉洁青山</a><i>/</i><a href="https://jubao.tssgroup.com.cn/start/#/news_web">廉洁新闻</a>
      </div>








      <!--news1-->
      <div class="news1 incont clearfix">
        <h3 class="l-text aos-init aos-animate" aos="fade-up">廉洁新闻</h3>
        <div class="min news-show">

          <h3>{{ detail.title }}</h3>
          <dd>
            <h4>发布时间：{{ detail.year }} 年 {{ detail.month }} 月 {{ detail.day }} 日</h4>
            <h4>访问次数：{{ detail.watchCount }}次</h4>
          </dd>


          <dt>
            <div v-html="detail.htmlContent"></div>
<!--            {{detail.htmlContent}}-->
          </dt>




        </div>
      </div>


    </div>


    <div class="footer">
      <div class="center">

        <div class="top">
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/about-us/group/">走进青山</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/about-us/group/"><span></span>集团简介</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/about-us/honor/"><span></span>集团荣誉</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/about-us/video/"><span></span>影像集锦</a></h4>
          </dd>
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/global/steel/">全球业务</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/global/steel/"><span></span>不锈钢制造</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/global2new/"><span></span>新能源产业链</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/global/innovation/"><span></span>创新与发展</a></h4>
          </dd>
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/duty1/"><span></span>社会责任</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/duty1/"><span></span>生态环保</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/duty2/"><span></span>慈善公益</a></h4>
          </dd>
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/ts-news/news1/">资讯中心</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/ts-news/news1/"><span></span>企业动态</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/ts-news/news2-1/"><span></span>行业新闻</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/ts-news/news2/"><span></span>媒体聚焦</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/ts-news/news3/"><span></span>活动剪影</a></h4>
          </dd>
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/job/join1/">加入我们</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/job/join1/"><span></span>职业发展</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/job/join2/"><span></span>诚聘英才</a></h4>
          </dd>
          <dd>
            <h3><a href="https://www.tssgroup.com.cn/contact/contact-us/">联系我们</a></h3>
            <h4><a href="https://www.tssgroup.com.cn/contact/contact-us/"><span></span>联系方式</a></h4>
            <h4><a href="https://www.tssgroup.com.cn/contact/line/"><span></span>互动留言</a></h4>
          </dd>
<!--          <dt>-->
<!--            <img src="/style/images/202004011521.jpg">-->
<!--            <span><i>微信扫码</i>关注青山微信公众号</span>-->
<!--          </dd>-->
        </div>

        <div class="bottom">
          <h3>©  版权所有：青山控股集团有限公司<a href="https://beian.miit.gov.cn" target="blank">浙ICP备11014192号-1</a>

            <strong>
              <span>友情链接</span><div class="fa fa-caret-down"></div>
              <font>
                <a target="_blank" href="http://www.tsingtuo.com/">青拓集团有限公司</a>
                <a target="_blank" href="http://www.etsingshan.com/">永青集团有限公司</a>
                <a target="_blank" href="http://www.decent-china.com/">上海鼎信投资(集团)有限公司</a>
                <a target="_blank" href="http://www.chinarept.com/">永青科技股份有限公司（瑞浦能源）</a>
                <a target="_blank" href="http://www.j-eray.com/index_cn.aspx">广东吉瑞科技集团</a>
              </font>
            </strong>

          </h3>
          <h4>
            <a href="https://www.tssgroup.com.cn/sitemap/" style=" ">Sitemap</a>

            <a href="http://www.songyi.net" target="_blank" style="opacity: 0;font-size:0;">Powered by SE</a>
          </h4>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

import request from '@/api/request'
// import './css/news.css';
export default {
  name: "news",
  data(){
    return{
      current:1,
      total:0,
      size:6,
      detail:{
        watchCount:0,
        title:"",
        releaseTime:""
      }
    }
  },
  mounted() {
    // console.log(this.$route.params.id);
    this.getDetail(this.$route.params.id);
  },
  created() {
    // this.getDetail(this.$route.params.id);
    // this.getDetail();
  },
  methods:{
    handleCurrentChange(val) {
      this.current=val;
      console.log(`当前页: ${val}`);
      this.getDataList();
    },
    //获取数据
    getDetail(id){
      let httpURL = `/news/view_pub/`+id; //目标地址后接的详细地址
      let data= {
        // current:this.current,
        // size:this.size
      };
      let that=this;
      request.post(httpURL,data).then(function (res) {
        // console.log(res);
        if (res.code == "0") {
          // console.log(res);
          // that.tableData=res.rows;
          let resData=res.data;
          let time=resData.releaseTime;
          let date=new Date(time);
          resData.year=date.getFullYear();
          resData.month=that.doHandleZero(date.getMonth()+1);
          resData.day=that.doHandleZero(date.getDate());
          // for(let i=0;i<resData.length;i++){
          //   resData[i].releaseTime=(resData[i].releaseTime).substring(0,10);
          // }
          //替换背景色
          const text = resData.htmlContent;
          const regex = /background-color:\s*#([0-9A-Fa-f]{6});/g;
          let match;
          let backgroundColor="";
          while ((match = regex.exec(text)) !== null) {
            backgroundColor= match[1];
          }
          if(backgroundColor!=""){
            // 使用正则表达式替换所有<p>标签，添加背景色
            const replacedText  = text.replace(/<p\b([^>]*)>/g, (match, p1) => {
                // 如果<p>标签已经有style属性，则在原有style基础上添加背景色
                if (p1.includes('style="')) {
                    return `<p${p1.replace(/style="([^"]*)"/, `style="$1; background-color: ${backgroundColor};"`)}>`;
                } else {
                    // 如果<p>标签没有style属性，则直接添加style属性
                    return `<p${p1} style="background-color: ${backgroundColor};">`;
                }
            });
            resData.htmlContent=replacedText;
          }
          if(that._isMobile()){
            resData.htmlContent = resData.htmlContent.replace(/<video\b/g, '<video muted autoplay style="width:280px;height:180px"');
          }else{
            resData.htmlContent = resData.htmlContent.replace(/<video\b/g, '<video muted autoplay style="width:700px;height:320px"');
          }

          that.detail=resData;
          // that.total=res.total;
        }
      })
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    // 补零函数
    doHandleZero(zero) {
      var date = zero;
      if (zero.toString().length == 1) {
        date = "0" + zero;
      }
      return date;
    }

  }
}
</script>

<style scoped>
.container{
  position : absolute;
  top:0;
  left: 0;
}

.header {
  background-color: rgba(67,67,67,0.95);
}

/deep/.el-pagination span{
  background: #574225;
  border: 1px solid #fdd000;
  color: #FFFFFF;
  padding: 0 5px;
  line-height: 2;
  border-radius: 4px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled){
  background-color: #FFFFFF;
  color: #000;
  border-radius: 90px;
  /*size: 60px;*/
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fdd000;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/newsDetail.vue